import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Header from "../components/Header"
import LanguageSet from "../components/language/LanguageSet"
import LanguageContext from "../components/hooks/LanguageContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSnipQuiz from "../components/LoadingSnipQuiz";
import { ToastContainer, toast } from 'react-toastify';
import Constants from "../common/Constants";
import apiCall, { apiCall2 } from "../api";
import { useAuth } from "../providers/AuthProvider";
import ConsentForm from "./baseline/ConsentForm";
import QuizIntro from "./survey/QuizIntro";
import VideoSection from "./survey/VideoSection";
import QuizQuestionSection from "./survey/QuizQuestionSection";
import { getText } from "../utils/languageUtils";

const SurveyQuiz = () => {
    const { user, authToken, logout: authLogout,  surveyId, authDispatch, updateUser } = useAuth(); // Use useAuth
    const navigate = useNavigate();
    const { language, translations: translationData } = useContext(LanguageContext);
console.log(language, translationData);
    const [loading, setLoading] = useState(true);
    const [nextPrevBtnShow, setNextPrevBtnShow] = useState(false);
    const [showVideo, setShowVideo] = useState(true)
    const [data, setData] = useState("")



    const [sectionUrl, setSectionUrl] = useState(null)
    const [question, setQuestion] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [selectedOptions, setSelectedOptions] = useState({
        question_type: "",
        question_id: "",
        values: "",
        input_option_id: "",
        answer: "",
    });
    const [textValue, setTextValue] = useState("")
    const [error, setError] = useState("");
    // const [surveyId, setSurveyId] = useState("")
    const [questionId, setQuestionId] = useState("")


    const [, setAnswer] = useState("");
    const [, setIsMarked] = useState(0)
    const [, setFinalSubmit] = useState(false)
    const [optionMarked, setOptionMarked] = useState({})
    const [videoData, setShowVideoData] = useState("")
    const [startQuiz, setStartQuiz] = useState(false)
    const [nextBtnEnable, setNextBtnEnable] = useState(true)


    // State to store the selected age
    const [selectedAge, setSelectedAge] = useState("");
    //Grade List
    const [gradeList, setGradeList] = useState([])
    const [selectedGrade, setSelectedGrade] = useState("");
    // Gender List
    const [selectGender, setSelectedGender] = useState("");

    const [showConsentForm, setShowConsentForm] = useState(user?.is_consent === 0 ? true : false)
    const [consentFormData, setConsentFormData] = useState("");

    const [dataConsent, setDataConsent] = useState(true);
    const [quizStage, setQuizStage] = useState("loading");

    const questionViewStartedAtRef = useRef(null);
    const stayDurationQuestionIdRef = useRef(null);

    useEffect(() => {
        if (quizStage !== "quiz" || !questionId) return;
        if (loading) return;
        if (stayDurationQuestionIdRef.current !== questionId) {
            stayDurationQuestionIdRef.current = questionId;
            questionViewStartedAtRef.current = Date.now();
        }
    }, [questionId, loading, quizStage]);

    const getStayDurationSeconds = () => {
        const start = questionViewStartedAtRef.current;
        if (start == null) return 0;
        return Math.max(0, Math.round((Date.now() - start) / 1000));
    };

    // Event handler for the "Next" button click
    const handleNextClickAge = async (url) => {
        if (selectedAge !== "" && selectedGrade !== "" && selectGender !== "") {
            // Here, you can use the selectedAge value as needed
            // For example, you can submit it to a server or update your application's state.

            // For now, let's log the selected age to the console
            try {
                setLoading(true)
                const formData = new FormData();
                formData.append("age", selectedAge);
                formData.append("grade_id", selectedGrade);
                formData.append("gender_id", selectGender);
                formData.append("access_token", authToken);

                const response = await apiCall({ url: `student-update-age`, method: "POST", data: formData, });

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    if (response.data.status === 1) {
                        navigate("/surveyQuiz");
                        let newUrl = `${url}&access_token=${authToken}`;

                        setSectionUrl(newUrl);
                        setQuizStage('quiz')
                    } else if (response.data.status === 2) {

                        toast.error(response?.data?.message);

                    }

                }
            } catch (error) {
                console.error(error);
                toast.warn("An error occurred. Please try again.");
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }

            // Navigate to the next page (e.g., SurveyQuiz)

        } else {
            // Handle the case where no age is selected
            toast.warn("Please select your age, gender and grade.");
        }
    };



    useEffect(() => {
        const url = `survey`;
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await apiCall({ url: url, method: "GET" });
                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                    return;
                }

                setData(response.data);
                const surveyIdValue = response.data.survey_summary.survey_id;
                authDispatch({ type: "SET_SURVEY_ID", payload: surveyIdValue });
                const totalQuestions = Number(response.data.survey_summary.total_questions) || 0;

                const getAge = `site/student-age`;

                const response2 = await apiCall({ url: getAge, method: "GET" });
                if (response2.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                    return;
                }

                setSelectedAge(response2.data.student_summary.age)
                setSelectedGrade(Number(response2.data.student_summary.grade))
                setSelectedGender(Number(response2.data.student_summary.gender_id))

                if (user?.is_consent === 0) {
                    setQuizStage('consent')
                } else if (totalQuestions === 0) {
                    // Already consented and no active survey questions — nothing for the intro/video/quiz to cover, skip straight to completion.
                    await finalSubmitReq(surveyIdValue);
                } else {
                    setQuizStage('video')
                }

            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }

        fetchData();
    }, [startQuiz, user])


    useEffect(() => {
        const fetchData = async () => {

            let url = `${sectionUrl}&page=${currentPage}`

            try {
                setLoading(true);
                const response = await axios.get(url);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                    return;
                }

                if (!response?.data?.survey_question?.length) {
                    // No survey questions exist for this survey (e.g. all removed) — nothing to quiz on, finalize immediately.
                    await finalSubmitReq();
                    return;
                }

                setNextPrevBtnShow(true)
                setQuestion(response.data)
                setTotalCount(response?.data?.summary?.total_page)
                setCurrentPage(response?.data?.summary?.current_page)
                // setSurveyId(response?.data?.survey_question[0]?.survey_id)
                setQuestionId(response?.data?.survey_question[0]?.id)
                // setHtmlData(HTMLReactParser(response?.data?.survey_summary?.description[language]));

                let answerUrl = `${Constants.BASE_URL}/survey-response?access_token=${authToken}&page=${currentPage}&survey_id=${surveyId}`;

                const response2 = await axios.get(answerUrl);
                if (response2.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    const questionType = response.data.survey_question[0].question_type || "single_select";
                    const answeredQuestion = response2.data.survey_question[0];

                    setIsMarked(answeredQuestion.is_marked)
                    setOptionMarked(answeredQuestion.option_marked)
                    setFinalSubmit(answeredQuestion.is_final_submit)

                    // Update selectedOptions based on the question type
                    if (questionType === "input_radio") {
                        setSelectedOptions({
                            question_type: questionType,
                            question_id: response.data.survey_question[0].id,
                            values: answeredQuestion.option_marked,
                            input_option_id: response.data.survey_question[0].input_option_id,
                            answer: "",
                        });
                        setTextValue(answeredQuestion.option_marked?.answer || "");
                    } else if (questionType === "input") {
                        setSelectedOptions({
                            question_type: questionType,
                            question_id: answeredQuestion.id,
                            values: "",
                            input_option_id: "",
                            answer: answeredQuestion.option_marked?.answer || "",
                        });
                        setTextValue("");
                    } else if (questionType === "multiple_select") {
                        // option_marked expected to be an array of selected option objects
                        const marked = answeredQuestion.option_marked;
                        setSelectedOptions({
                            question_type: questionType,
                            question_id: answeredQuestion.id,
                            values: Array.isArray(marked) ? marked.map(o => o.id) : [],
                            input_option_id: "",
                            answer: answeredQuestion.answer || "",
                        });
                        setTextValue("");
                    } else {
                        setSelectedOptions({
                            question_type: "single_select",
                            question_id: answeredQuestion.id,
                            values: answeredQuestion.option_marked,
                            input_option_id: "",
                            answer: "",
                        });
                        setTextValue("");
                    }
                    setError("");
                    if (answeredQuestion.is_marked === 1) {
                        setNextBtnEnable(true)
                    }
                }

            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }
        if (sectionUrl !== null) {
            fetchData();
        }

    }, [sectionUrl, currentPage])

    const startSection1 = (url) => {
        handleNextClickAge(url);
    }
    const handleOptionChange = (question_type, question_id, values) => {
        setOptionMarked({})

        setSelectedOptions(prevOptions => ({
            ...prevOptions,
            question_type: question_type,
            question_id: question_id,
            ...(question_type === "input" ? { answer: values } : { values: values })
        }))
        setNextBtnEnable(true)
    };

    const handleOtherChange = (question_id, value) => {
        setSelectedOptions(prev => ({
            ...prev,
            question_id,
            answer: value
        }))
    }

    const handleTextChange = (value) => {
        setError("")

        setTextValue(value)
    }

    const buildMarkasdoneUrl = (submitSurveyId) => {
        let submitUrl = "";
        if (selectedOptions.question_type === "single_select") {
            // For single select, use the "option_id" property in the API request
            submitUrl = `${Constants.BASE_URL}/survey-markasdone?survey_id=${submitSurveyId}&survey_question_id=${questionId}&option_id=${selectedOptions.values.id}&access_token=${authToken}`;
        } else if (selectedOptions.question_type === "input") {
            // For textarea, use the "answer" property in the API request
            submitUrl = `${Constants.BASE_URL}/survey-markasdone?survey_id=${submitSurveyId}&survey_question_id=${questionId}&answer=${encodeURIComponent(selectedOptions.answer || '')}&access_token=${authToken}`;
        } else if (selectedOptions.question_type === "input_radio") {
            if (textValue.length > 0) {
                submitUrl = `${Constants.BASE_URL}/survey-markasdone?survey_id=${submitSurveyId}&survey_question_id=${questionId}&option_id=${selectedOptions.values.id}&answer=${encodeURIComponent(textValue)}&access_token=${authToken}`;
            } else if (textValue.length === 0 && selectedOptions.values.id === selectedOptions.input_option_id) {
                toast.warn("Please mark your answer.");
                setError("Please mark your answer.")
                return null;
            } else {
                submitUrl = `${Constants.BASE_URL}/survey-markasdone?survey_id=${submitSurveyId}&survey_question_id=${questionId}&option_id=${selectedOptions.values.id}&access_token=${authToken}`;
            }
        } else if (selectedOptions.question_type === "multiple_select") {
            const valuesArray = Array.isArray(selectedOptions.values) ? selectedOptions.values : [];
            if (valuesArray.length === 0) {
                toast.warn("Please choose at least one option.");
                return null;
            }
            const csvIds = valuesArray.join(",");
            const otherAnswer = selectedOptions.answer ? `&answer=${encodeURIComponent(selectedOptions.answer)}` : '';
            submitUrl = `${Constants.BASE_URL}/survey-markasdone?survey_id=${submitSurveyId}&survey_question_id=${questionId}&options=${csvIds}${otherAnswer}&access_token=${authToken}`;
        }

        if (!submitUrl) return null;
        return `${submitUrl}&stay_duration=${getStayDurationSeconds()}`;
    }

    const resetSelectedOptions = () => {
        setSelectedOptions({
            question_type: "",
            question_id: "",
            values: "",
            input_option_id: "",
            answer: "",
        });
        setTextValue("");
        setError("");
    }

    const handleNextClick = async () => {
        setNextBtnEnable(false);
        if (isNoSelectionForCurrent) {
            toast.error("Please select a option");
            setNextBtnEnable(true);
            return;
        }

        if (Number(currentPage) < Number(totalCount)) {
            const submitUrl = buildMarkasdoneUrl(surveyId);
            if (!submitUrl) {
                setNextBtnEnable(true);
                return;
            }

            try {
                setLoading(true);

                const response = await apiCall2({ url: submitUrl, method: "POST" });

                if (response?.data?.message === "Invalid Access Token") {
                    authLogout();
                    navigate("/");
                    return;
                }

                const httpOk =
                    response &&
                    response.status >= 200 &&
                    response.status < 300;
                const success = httpOk && response?.data?.success === true;

                if (success) {
                    setAnswer(response.data);
                    setCurrentPage((p) => Number(p) + 1);
                    resetSelectedOptions();
                } else {
                    toast.error(
                        response?.data?.message ||
                            "Could not save your answer. Please try again."
                    );
                    setNextBtnEnable(true);
                }
            } catch (error) {
                console.error(error);
                const msg =
                    error?.data?.message ||
                    error?.message ||
                    "An error occurred. Please try again.";
                toast.error(msg);
                setNextBtnEnable(true);
            } finally {
                setLoading(false);
            }
        } else if (Number(currentPage) === Number(totalCount)) {
            setFinalSubmit(true);
            setNextBtnEnable(true);
        } else {
            setCurrentPage(1);
            setNextBtnEnable(true);
        }
    };

    const handlePreviousClick = () => {
        if (Number(currentPage) !== 1) {
            setCurrentPage(Number(currentPage) - 1)
        } else if (Number(currentPage) === 1) {
            setCurrentPage(1)
            navigate("/")
        } else {
            setCurrentPage(1)
        }
    }

    useEffect(() => {
        let url = `${Constants.BASE_URL}/survey-video?access_token=${authToken}`;



        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(url);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    setShowVideoData(response.data)
                }
            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }

        fetchData();
    }, [showVideo, authToken, navigate])


    useEffect(() => {
        let url = `${Constants.BASE_URL}/student-grade-list?access_token=${authToken}`;
        let url2 = `${Constants.BASE_URL}/consent-detail?access_token=${authToken}`;

        const fetchData = async () => {
            try {
                setLoading(true);
                // const response = await axios.get(url);

                const [response, concentDetail] = await Promise.all([
                    axios.get(url),
                    axios.get(url2)
                ])

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    // setShowVideoData(response.data)
                    setGradeList(response.data.class_summary)
                }

                if (concentDetail.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    setConsentFormData(concentDetail?.data?.consent_summary)
                }

            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }

        fetchData();
    }, [])

    const isNoSelectionForCurrent = useMemo(() => {
        if (!selectedOptions || !selectedOptions.question_type) return true;
        if (selectedOptions.question_type === "multiple_select") {
            return !Array.isArray(selectedOptions.values) || selectedOptions.values.length === 0;
        }
        if (selectedOptions.question_type === "single_select") {
            return !selectedOptions.values || !selectedOptions.values.id;
        }
        if (selectedOptions.question_type === "input") {
            return !selectedOptions.answer || String(selectedOptions.answer).trim().length === 0;
        }
        if (selectedOptions.question_type === "input_radio") {
            if (!selectedOptions.values || !selectedOptions.values.id) return true;
            if (selectedOptions.values.id === selectedOptions.input_option_id) {
                return String(textValue).trim().length === 0;
            }
            return false;
        }
        return true;
    }, [selectedOptions, textValue]);

    const requiresOtherAnswer = useMemo(() => {
        if (selectedOptions?.question_type !== "multiple_select") return false;
        const currentQ = question?.survey_question?.[0];
        if (!currentQ || !Array.isArray(currentQ.options)) return false;
        const otherOpt = currentQ.options.find(o => Number(o.has_oth) === 1);
        if (!otherOpt) return false;
        const isOtherSelected = Array.isArray(selectedOptions.values) && selectedOptions.values.map(Number).includes(Number(otherOpt.id));
        if (!isOtherSelected) return false;
        return !(selectedOptions.answer && String(selectedOptions.answer).trim().length > 0);
    }, [question, selectedOptions]);

    const finalSubmitReq = async (surveyIdOverride) => {

        const submitSurveyId = surveyIdOverride ?? surveyId;

        try {
            setLoading(true);
            if (!isNoSelectionForCurrent) {
                const submitUrl = buildMarkasdoneUrl(submitSurveyId);
                if (!submitUrl) {
                    setLoading(false);
                    return;
                }
                const response = await axios.post(submitUrl);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    resetSelectedOptions()
                }
            }

            // Call the second API using data from the first API
            const response2 = await fetch(`${Constants.BASE_URL}/survey-final-submit?access_token=${authToken}&survey_id=${submitSurveyId}`);
            const data2 = await response2.json();

            if (data2?.summary?.final_submit_status === 1) {
                authDispatch({ type: "SET_AGE_SUBMITTED", payload: true });
                authDispatch({ type: "SET_BASELINE_QUIZ_COMPLETED", payload: true });
                navigate("/")
            } else {
                toast.error(data2?.summary?.message);
            }
        } catch (error) {
            console.error(error);
            resetSelectedOptions()
        } finally {
            // Set loading to false when the request is complete
            setLoading(false);
        }

    }

    const submitConsentForm = async () => {
        if (dataConsent === false) {
            toast.error("Please select terms and condition.");
            return
        } else if (dataConsent === true) {

            try {
                setLoading(true)
                const url = `${Constants.BASE_URL}/student-consent`;
                const formData = new FormData();
                formData.append("access_token", authToken);
                formData.append("consent", 1);
                const response = await axios.post(
                    url,
                    formData,
                    {
                        headers: {
                            'x-api-key': 'fc9f4a47-4f7f-41ba-a656-d30e0009d6f0',
                            "Access-Control-Allow-Origin": "*"
                        },
                    }
                );


                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    setShowConsentForm(false)
                    updateUser({ is_consent: 1 })

                    if (Number(data?.survey_summary?.total_questions) > 0) {
                        setQuizStage('video');
                    } else {
                        // No active survey questions — nothing for the video/intro/quiz to cover, skip straight to completion.
                        await finalSubmitReq(data?.survey_summary?.survey_id);
                    }
                }
            } catch (error) {
                console.error(error);
                toast.warn("An error occurred. Please try again.");
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }


    }

    const renderItem = () => {
        switch (quizStage) {
            case "consent":
                return <ConsentForm
                    consentFormData={consentFormData}
                    dataConsent={dataConsent}
                    setDataConsent={setDataConsent}
                    submitConsentForm={submitConsentForm}
                    language={language}
                    translationData={translationData}
                />
            case "intro":
                return <QuizIntro
                    data={data}
                    gradeList={gradeList}
                    selectedGrade={selectedGrade}
                    setSelectedGrade={setSelectedGrade}
                    selectGender={selectGender}
                    setSelectedGender={setSelectedGender}
                    language={language}
                    startSection1={startSection1}
                    translationData={translationData}
                />
            case "video":
                return <VideoSection
                    videoData={videoData}
                    language={language}
                    setQuizStage={setQuizStage}
                    setStartQuiz={setStartQuiz}
                    translationData={translationData}
                />
            case "quiz":
                return (
                    <>
                        {loading && <LoadingSnipQuiz />}
                        <QuizQuestionSection
                            question={question}
                            handleNextClick={handleNextClick}
                            handlePreviousClick={handlePreviousClick}
                            selectedOptions={selectedOptions}
                            nextBtnEnable={nextBtnEnable}
                            currentPage={currentPage}
                            totalCount={totalCount}
                            finalSubmitReq={finalSubmitReq}
                            loading={loading}
                            language={language}
                            optionMarked={optionMarked}
                            handleOptionChange={handleOptionChange}
                            translationData={translationData}
                            textValue={textValue}
                            handleTextChange={handleTextChange}
                            error={error}
                            handleOtherChange={handleOtherChange}
                            isNoSelectionForCurrent={isNoSelectionForCurrent}
                            requiresOtherAnswer={requiresOtherAnswer}
                        />
                    </>
                );
            default:
                return <LoadingSnipQuiz />;
        }
    }

    return (
        <>
            <div id="body_bg">
                {user && (
                    <Header
                        page_title={
                            (getText(user?.student_name, language) || "") + " (" + user?.student_id + ")"
                        }
                        pageTitle="AskAge"
                    />
                )}

                <LanguageSet pageTitle={"AskAge"} />
                {renderItem(quizStage)}

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div >
        </>
    )
}

export default SurveyQuiz